import queryString from 'query-string';
import { fetchWithErrorHandling, noticeError } from '@ratehub/base-ui';


// Very similar to fetchJSON but we need to get some information from the header
async function fetchPosts(target, callerName = '') {
    let url = target.url || target;

    if (target.params) {
        url += '?' + queryString.stringify(target.params, {
            arrayFormat: target.arrayFormat || 'bracket',
        });
    }

    // Initializing this outside of the try lets the catch
    // include it in the noticeError in the event of failure.
    let text;

    try {
        const response = await fetchWithErrorHandling(url);

        // Get the total number of pages in the complete result
        // set so a caller can know if it needs to request another
        // page or not.
        const totalPages = response.headers.get('X-WP-TotalPages');
        text = await response.text();

        return {
            totalPages: totalPages,
            posts: JSON.parse(text),
        };
    } catch (e) {
        // Write a helpful debugging message. Helpful when running minified on the server.
        // eslint-disable-next-line
        console.error(`${callerName} failed when fetching JSON from URL:${url}\nError:`, e);

        noticeError(new Error(`[fetchPosts] ${callerName} failed when fetching JSON from URL`), {
            url,
            text,
        });

        // Re-throw to allow for proper handling.
        throw e;
    }
}

export default fetchPosts;
